let isDev = false;

let config = {
    dev: {
        apiDomain: "https://testapi.minglemint.com",
        bucketOption: {
            BucketName: 'minglemint-dev-real',
            BucketRegion: 'ap-northeast-2',
            BucketIdentityPoolId: 'ap-northeast-2:76a65f97-bc86-46d0-a35a-16574af89e2a',
        },
        nftBucketOption: {
            BucketName: 'minglemint-dev-real-nft',
            BucketRegion: 'ap-northeast-2',
            BucketIdentityPoolId: 'ap-northeast-2:76a65f97-bc86-46d0-a35a-16574af89e2a',
        },
        searchElaUrl: '',
    },
    prod: {
        apiDomain: "https://api.minglemint.com",
        bucketOption: {
            BucketName: 'minglemint-dev',
            BucketRegion: 'ap-northeast-2',
            BucketIdentityPoolId: 'ap-northeast-2:76a65f97-bc86-46d0-a35a-16574af89e2a',
        },
        nftBucketOption: {
            BucketName: 'minglemint-dev-nft',
            BucketRegion: 'ap-northeast-2',
            BucketIdentityPoolId: 'ap-northeast-2:76a65f97-bc86-46d0-a35a-16574af89e2a',
        },
        searchElaUrl: '',
    },
}


function getConfig(key = 'apiDomain') {
    return isDev ? config.dev[key] : config.prod[key];
}

function setConfig(key, value) {
    if (isDev) {
        config.dev[key] = value;
    } else {
        config.prod[key] = value;
    }
}

let apiDomain = getConfig('apiDomain')
let apiURL = `${getConfig('apiDomain')}/api/`;
let bucketOption = getConfig('bucketOption');
let nftBucketOption = getConfig('nftBucketOption');
let searchElaUrl = getConfig('searchElaUrl')

function setterApiDomain(domain) {
    setConfig('apiDomain', domain);
    apiDomain = getConfig('apiDomain');
    apiURL = `${getConfig('apiDomain')}/api/`;
}


export {apiURL, searchElaUrl, apiDomain, bucketOption, nftBucketOption, setterApiDomain,};
